module.exports = __webpack_public_path__ + "img/icons B_21.b76f8c91.svg";